import { render, staticRenderFns } from "./BudgetSelect.vue?vue&type=template&id=5b1fc8c8&lang=pug&"
import script from "./BudgetSelect.vue?vue&type=script&lang=js&"
export * from "./BudgetSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports